module.exports = __webpack_public_path__ + "img/core-2.84ef5c9c.png";